module.exports = __webpack_public_path__ + "img/logo-login.cf7c75f6.png";